import React from 'react';
import {Route, Switch} from 'react-router-dom';

import * as routePaths from '../../consts/route/routePaths';
import BrowserVerificationPage from '../BrowserCompatibility/BrowserVerificationPage/BrowserVerificationPage';
import NotAvailablePage from '../NotAvailablePage/NotAvailablePage';
import Root from '../Root/Root';
import TNC from '../TNC/TNC';
import AppRoute from './AppRoute';
import loadableRoutes from './loadableRoutes';

const Routes = () => {
    return (
        <Switch>
            <Route exact path={routePaths.ROOT} component={Root} />
            <AppRoute path={routePaths.AGE_GATE} component={loadableRoutes.AgeGatePage} />
            <AppRoute path={routePaths.CONTACT_US} component={loadableRoutes.ContactUsPage} />
            <AppRoute path={routePaths.CHECKING_UPDATE} component={loadableRoutes.CheckingUpdatePage} />
            <AppRoute path={routePaths.APP_LOCKED} component={loadableRoutes.AppLockedPage} />
            <AppRoute path={routePaths.BROWSER_VERIFICATION} component={BrowserVerificationPage} />
            <AppRoute path={routePaths.CANNOT_DETECT_LOCATION} component={loadableRoutes.CannotDetectLocationPage} />
            <AppRoute path={routePaths.PAIRING_GUIDE_HID_PARAMETRIZED} component={loadableRoutes.PairingGuideHid} />
            <AppRoute path={routePaths.LEGAL_DISCLAIMER} component={loadableRoutes.LegalDisclaimerPage} />
            <AppRoute path={routePaths.ERROR_PAGE} component={loadableRoutes.ErrorHandlingPage} />
            <AppRoute path={routePaths.IMPORTANT} component={loadableRoutes.ImportantPage} />
            <AppRoute path={routePaths.NOT_AVAILABLE} component={NotAvailablePage} />
            <AppRoute path={routePaths.NOT_COMPATIBLE_BROWSER} component={loadableRoutes.NotCompatibleBrowserPage} />
            <AppRoute path={routePaths.PAIRING_ALERT} component={loadableRoutes.PairingAlertPage} />
            <AppRoute
                path={routePaths.PAIRING_GUIDE_PARAMETERIZED}
                component={loadableRoutes.PairingGuidePage}
                isFullScreen
            />
            <AppRoute path={routePaths.PAIRING_SUCCESS} component={loadableRoutes.PairingSuccessPage} />
            <AppRoute path={routePaths.RESET_DEVICE} component={loadableRoutes.ResetDevicePage} />
            <AppRoute path={routePaths.SELECT_DEVICE} component={loadableRoutes.SelectYourDevicePage} />
            <AppRoute path={routePaths.SUMMARY_UPDATE} component={loadableRoutes.SummaryUpdatePage} />
            <AppRoute path={routePaths.CONNECTING} component={loadableRoutes.DeviceConnectingPage} />
            <AppRoute path={routePaths.TNC} component={TNC} />
            <AppRoute path={routePaths.UPDATE} component={loadableRoutes.UpdateFWPage} isFullScreen />
            <AppRoute path={routePaths.UP_TO_DATE_PARAMETERIZED} component={loadableRoutes.UpToDatePage} />
            <AppRoute path={routePaths.UP_TO_DATE_FAILED} component={loadableRoutes.UpToDateFailedPage} />
        </Switch>
    );
};

export default Routes;
